"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const contentConversionSteps_1 = require("./contentConversionSteps");
exports.contentConversionDetailData = graphql_tag_1.default `
  fragment contentConversionDetailData on ContentConversion {
    id
    name
    createdAt
    resourceUrl
    resourceEndpoint
    steps {
      ...contentConversionStepDetailData
    }
  }
  ${contentConversionSteps_1.contentConversionStepDetailData}
`;
//# sourceMappingURL=contentConversions.js.map